// extracted by mini-css-extract-plugin
module.exports = {"best-deals-container":"BestDeals_best-deals-container__ZONOc","best-deals":"BestDeals_best-deals__1EcBM"};